import { create } from 'zustand';
import { User } from '../types';
import authService from '../services/auth.service';
import { initAuthState } from '../utils/authSession';
import { useOrderStore } from './orderStore';

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  authInitialized: boolean;
  setUser: (user: User | null) => void;
  logout: () => void;
  initAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  isAuthenticated: false,
  authInitialized: false,
  
  setUser: (user) => {
    const prevId = get().user?.id;
    set({ user, isAuthenticated: !!user });
    if (!user || (prevId != null && user.id !== prevId)) {
      useOrderStore.getState().resetCart();
    }
  },
  
  logout: () => {
    authService.logout();
    useOrderStore.getState().resetCart();
    set({ user: null, isAuthenticated: false, authInitialized: true });
  },
  
  initAuth: async () => {
    if (!authService.isAuthenticated()) {
      useOrderStore.getState().resetCart();
      set({ user: null, isAuthenticated: false, authInitialized: true });
      return;
    }
    const user = await initAuthState();
    set({ user, isAuthenticated: !!user, authInitialized: true });
  },
}));
